export default "__VITE_ASSET__r0p6dh44__"